import { useCallback } from 'react';
import { useValueRef } from './useValueRef';

/**
 * Put a callback in a ref for use in useCallback/useEffect
 * This way, the outer callback (the proxy) will always be the same function, so it won't
 * affect other callbacks/effects that have it as a dependency.
 */
export const useCallbackProxy = <T extends (...args: Array<any>) => any>(callback: T): T => {
  const callbackRef = useValueRef(callback);
  return useCallback((...args: Array<any>) => callbackRef.current(...args), [callbackRef]) as T;
};
